import './App.css';
import Canvas from './components/Canvas/Canvas';
import { Checklist } from './components/Checklist/Checklist';
import { Controls } from './components/Controls/Controls';
import { Debugger } from './components/Debugger/Debugger';
import MobilePopup from './components/MobilePopup/MobilePopup';
import { PSABanner } from './components/PSABanner/PSABanner';
import { SettingsBar } from './components/SettingsBar/SettingsBar';
import TopMenu from './components/SettingsMenu/TopMenu';
import Toolbar from './components/Toolbar/Toolbar';
import { LocalStorageCheck } from './components/LocalStorageWarning/LocalStorageCheck';
import { AppStateProvider } from './context/AppState/AppState';
import { MouseEventsProvider } from './context/MouseEvents/MouseEvents';
import { useRoomId as useRoomIdImport } from './hooks/useRoomId';

function App({ useRoomId }: { useRoomId?: typeof useRoomIdImport }) {
  const canvasId = (useRoomId ?? useRoomIdImport)();
  return (
    <>
      <PSABanner />
      <div className="App">
        <AppStateProvider useRoomId={useRoomId}>
          <LocalStorageCheck canvasId={canvasId} />
          <MobilePopup />
          <TopMenu />
          <Toolbar />
          <Controls />
          <MouseEventsProvider>
            <Canvas />
          </MouseEventsProvider>
          <SettingsBar />
          <Debugger />
          <Checklist />
        </AppStateProvider>
      </div>
    </>
  );
}

export default App;
